
import React from 'react';
import * as yup from 'yup';
import { useDispatch, useSelector } from "react-redux";
import "./../Custom.css";
import { objectToFormData, findLodash } from '../../../../utils';
import { addCostCenterField, updateCostCenterField } from '../../../../actions/companySettings';
import { Input, Form, Button, Select } from 'antd';

const { Option } = Select;
const { TextArea } = Input;

const ValidationSchema = yup.object().shape({
  name: yup
    .string()
    .required('Please provide category name'),
  code: yup.string(),
  description: yup.string(),
});

const AddCostCenterField = (props) => {
  const { id: currentId, employeesData = [] } = props;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const costCenterFieldResponse = useSelector(state => state.companySetting.getCostCenterField || {});
  // const addCostCenterFieldResponse = useSelector(state => state.companySetting.addCostCenterField || {});

  React.useEffect(() => {
    form.resetFields();
    if (costCenterFieldResponse.success && currentId) {
      const editValues = findLodash(costCenterFieldResponse.data.response.costcenters, { id: currentId }) || {};
      form.setFieldsValue({
        name: editValues.name,
        code: editValues.code,
        description: editValues.description,
        user_id: editValues.user_id,
        is_enable: editValues.is_enable
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const handleSubmit = (values) => {
    const payload = {};
    [
      'code',
      'name',
      'description',
      'user_id',
      'is_enable'
    ].forEach(item => {
      payload[item] = values[item] || '';
    });

    payload.is_enable = true;

    ValidationSchema.validate(payload)
      .then(function ({ ...value }) {
        Object.keys(payload).forEach(key => {
          if (!payload[key] && key !== "is_enable") {
            delete payload[key];
          }
        });
        currentId ?
          dispatch(updateCostCenterField(objectToFormData({ ...payload, id: currentId.toString() }))) :
          dispatch(addCostCenterField(objectToFormData({ ...payload })));
        form.resetFields();
      })
      .catch(function (err) {
      });
  }

  const handleCancelButton = () => {
    form.resetFields();
    props.handleCancel();
  }

  return (
    <>
      <Form
        layout="vertical"
        form={form}
        onFinish={handleSubmit}
        className="modal-form custom-form small-width"
      >
        <Form.Item label="Cost Center Name" name="name"
          required={true}
          rules={[{ required: true, message: 'Please enter name' }]}>
          <Input placeholder="Enter Cost Center Name" maxLength={50} />
        </Form.Item>
        <Form.Item label="Cost Center Code" name="code">
          <Input placeholder="Enter Cost Center Code" />
        </Form.Item>
        <Form.Item name="user_id" label="Cost Center Head">
          <Select
            placeholder="Select Cost Center Head"
          >
            {employeesData && employeesData.map(({ user_id, name }) => <Option key={user_id} value={user_id}>{name}</Option>)}
          </Select>
        </Form.Item>
        <Form.Item label="Description" name="description">
          <TextArea
            placeholder="Enter Description"
            autoSize={{ minRows: 3, maxRows: 5 }}
          />
        </Form.Item>

        <Button key="1" htmlType="submit" className="formButton mt1">{currentId ? 'Update' : 'Save'}</Button>
        <Button key="2" className="cancelButton ml1 mt1" onClick={() => handleCancelButton()}>Cancel</Button>
      </Form>
    </>
  );
}

export default AddCostCenterField;

